import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2BookIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21 21.21",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21.21),
    children: [/*#__PURE__*/jsx("path", {
      d: "m15.833 3.52a27.694 27.694 0 0 1 4.206-.35.46.46 0 0 1 .326.125.444.444 0 0 1 .135.316v14.019a.449.449 0 0 1 -.444.444c-7.372.092-9.556 2.428-9.556 2.428v-14.907s-2.182-2.334-9.54-2.428a.46.46 0 0 0 -.327.128.444.444 0 0 0 -.133.316v14.019a.449.449 0 0 0 .444.444c7.372.092 9.556 2.428 9.556 2.428"
    }), /*#__PURE__*/jsx("path", {
      d: "m10.5 20.065a5.364 5.364 0 0 1 1.454-3.065 7.314 7.314 0 0 1 3.879-2.189v-13.87a.428.428 0 0 0 -.2-.356.533.533 0 0 0 -.439-.059 6.933 6.933 0 0 0 -3.237 2.024 5.364 5.364 0 0 0 -1.457 3.064"
    })]
  });
};

export { PM2BookIcon };
//# sourceMappingURL=book.js.map
